import { Basic } from '../basic.js';
/**
 * @class MSRTSPCamera
 * @extends Basic
 * @classdesc Видеопоток
 */
export class MSRTSPCamera extends Basic {
    constructor() {
        super();
        const shadowRoot = this.attachShadow({ mode: 'open' });
        shadowRoot.innerHTML = `<video controls style="width:100%; height:100%; object-fit:fill;">`;
        this._video = shadowRoot.querySelector('video');
        this.setautoplay(this.getAttribute("autoplay"));

        this.playCallback = (event) => {
            this.setautoplay(true);
        }
        this._video.addEventListener("play", this.playCallback);

        this.pauseCallback = (event) => {
            this.setautoplay(false);
        }
        this._video.addEventListener("pause", this.pauseCallback);

        this.afterSwitchBind = this.afterSwitch.bind(this);
        window.addEventListener("ms_message", this.afterSwitchBind);
    }

    static get observedAttributes() {
        return super.observedAttributes.concat([
            'autoplay',
            'url',
            'username',
            'password',
        ]);
    }

    get autoplay() {
        return this._autoplay;
    }
    set autoplay(value) {
        this.setautoplay(value);
    }

    /**
     * Имя ресурса для изображения фона
     * @type {string}
     */
    get resource() {
        return this._resource;
    }
    set resource(value) {
        this._resource = this.getResourceFromList(value);
        this._video.autoplay = this._autoplay;
        this._video.src = `resources/${this._resource}`;
        this._video.load();
        this.checkforVideo();
    }

    // URL-адрес видеокамеры (RTSP ссылка)
    get url() {
        return this._url;
    }
    set url(value) {
        this._url = value;
        if (this.isControlConnected) {
            this.connectToCamera();
        }
    }

    // userName для подключения к видеокамере
    get username() {
        return this._username;
    }
    set username(value) {
        this._username = value;
        if (this.isControlConnected) {
            this.connectToCamera();
        }
    }

    // пароль для подключения к видеокамере
    get password() {
        return this._password;
    }
    set password(value) {
        this._password = value;
        if (this.isControlConnected) {
            this.connectToCamera();
        }
    }

    setautoplay(value) {
        this._autoplay = this._toBool(value);
        this._video.autoplay = this._autoplay;
        this.checkforVideo();
    }

    checkforVideo() {
        if(this.checkforVideoInterval){
            clearInterval(this.checkforVideoInterval)
        }
        //Every 500ms, check if the video element has loaded
        this.checkforVideoInterval = setInterval(() => {
            if (this._video && this._video.readyState >= 3) {
                //This block of code is triggered when the video is loaded

                //your code goes here
                if (this.autoplay) {
                    this._video.muted = true;
                    this._video.play();
                } else {
                    this._video.pause();
                }

                //stop checking every half second
                clearInterval(this.checkforVideoInterval);
            }
        }, 500);
    }

    async connectToCamera() {
        if (!this.url) {
            return;
        }
        this.pc?.close();

        const cameraConfiguration = {
            url: this.url,
            userName: this.username,
            password: this.password,
            id: `${window.crypto.getRandomValues(new Uint32Array(1))}` // uniqueId, без него на стороне c# будут падать ошибки
        };

        const baseUrl = $sw.serverState.haveReserv
            ? `//${$sw.serverState.location.hostname}:${window.location.port}/rtsptowebrtcapi/`
            : `//${window.location.hostname}:${window.location.port}/rtsptowebrtcapi/`;

        this.pc = new RTCPeerConnection();

        this.pc.ontrack = ({ track, streams: [stream] }) => {
            track.onunmute = () => {
                this._video.srcObject = stream;
            };
        };

        this.pc.onicecandidate = async function (event) {
            if (event.candidate) {
                await fetch(`${baseUrl}add-ice-candidate`, {
                    method: 'POST',
                    body: JSON.stringify({
                        id: cameraConfiguration.id,
                        iceCandidate: event.candidate
                    }),
                    headers: { 'Content-Type': 'application/json' }
                });
            }
        };

        const offerResponse = await fetch(`${baseUrl}get-or-add-camera-stream`, {
            method: 'POST',
            body: JSON.stringify(cameraConfiguration),
            headers: { 'Content-Type': 'application/json' }
        });
        const offer = await offerResponse.json();
        await this.pc.setRemoteDescription(offer);
        const answer = await this.pc.createAnswer();
        await this.pc.setLocalDescription(answer);
        await fetch(`${baseUrl}set-answer`, {
            method: 'POST',
            body: JSON.stringify({
                id: cameraConfiguration.id,
                answer: this.pc.localDescription
            }),
            headers: { 'Content-Type': 'application/json' }
        });
    }

    afterSwitch(message) {
        const data = message.data;
        switch (data.event) {
            case "serverChanged":
                this.connectToCamera();
                break;
        }
    }

    connectedCallback() {
        // Обсудили, что нужно делать 1 вызов `get-or-add-camera-stream` после инициализации контрола и далее уже переподключаться из сеттеров,
        // если в них приходят изменения.
        // Если вызывать `get-or-add-camera-stream` 3 раза наподряд до инициализации контрола, то на сервере начинают падать ошибки.
        this.isControlConnected = true;
        this.connectToCamera();
    }

    disconnectedCallback() {
        this._video.removeEventListener("play", this.playCallback);
        this._video.removeEventListener("pause", this.pauseCallback);
        window.removeEventListener("ms_message", this.afterSwitchBind);
        clearInterval(this.checkforVideoInterval);
        super.disconnectedCallback();
    }
}